<template>
  <div class="tools-background">
    <div class="tools-container">
      <p class="title filter">
        <ReportReviewTiny />
      </p>
      
      <BFormCheckbox
        :model-value="showNormal"
        @update:model-value="handleShowNormalChange"
      />
      <p class="title filter">
        ShowCorrect
      </p>
      
      <BFormCheckbox
        :model-value="showWrong"
        @update:model-value="handleShowWrongChange"
      />
      <p class="title filter">
        ShowWrong
      </p>
      
      <BFormCheckbox
        :model-value="showBbox"
        @update:model-value="handleShowBboxChange"
      />
      <p class="title">
        ShowBBox
      </p>
      
      <BFormCheckbox
        :model-value="drawingMode"
        @update:model-value="handleDrawingModeChange"
      />
      <p class="title">
        DrawingMode
      </p>
      <MeasurementRulerToggle
        v-if="rulerAvailable && taskId"
        class="ruler-toggle"
        :task-id="taskId"
      />
      <BFormInput
        class="img-width-slider"
        :model-value="imgWidthPercentage"
        type="range"
        min="10"
        max="200"
        @update:model-value="handleImgWidthChange"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BFormCheckbox, BFormInput, CheckboxValue } from 'bootstrap-vue-next';
import ReportReviewTiny from './ReportReviewTiny.vue';
import MeasurementRulerToggle from '@/components/measurement/MeasurementRulerToggle.vue';

const emit = defineEmits<{
  (e: 'showNormal', value: boolean | CheckboxValue | CheckboxValue[] | undefined): void;
  (e: 'showWrong', value: boolean | CheckboxValue | CheckboxValue[] | undefined): void;
  (e: 'showBbox', value: boolean | CheckboxValue | CheckboxValue[] | undefined): void;
  (e: 'drawingMode', value: boolean | CheckboxValue | CheckboxValue[] | undefined): void;
  (e: 'imgWidthPercentage', value: string): void;
}>();

defineProps<{
  showBbox?: boolean | CheckboxValue | CheckboxValue[];
  drawingMode?: boolean | CheckboxValue | CheckboxValue[];
  showNormal?: boolean | CheckboxValue | CheckboxValue[];
  showWrong?: boolean | CheckboxValue | CheckboxValue[];
  showExcluded?: boolean | CheckboxValue | CheckboxValue[];
  imgWidthPercentage?: string;
  taskId?: string;
  rulerAvailable?: boolean;
}>();

const handleShowNormalChange = (value: boolean | CheckboxValue | CheckboxValue[] | undefined) => { 
  emit('showNormal', value);
};
const handleShowWrongChange = (value: boolean | CheckboxValue | CheckboxValue[] | undefined) => {
  emit('showWrong', value);
};
const handleShowBboxChange = (value: boolean | CheckboxValue | CheckboxValue[] | undefined) => {
  emit('showBbox', value);
};
const handleDrawingModeChange = (value: boolean | CheckboxValue | CheckboxValue[] | undefined) => {
  emit('drawingMode', value);
};
const handleImgWidthChange = (value: string | number | null) => {
  emit('imgWidthPercentage', value == null ? '' : String(value));
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/common/alignment" as *;

.title {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #212121;
  display: flex;
  align-items: center;
  margin: 0 8px;
}

.tools-background {
  position: fixed;
  display: flex;
  top: 70px;
  width: calc(100% - 240px); /* adjust based on sidebar width */
  padding: 10px;
  background: rgb(238, 238, 238);
  z-index: 2;
  overflow-x: auto;
}

.tools-container {
  display: flex;
  align-items: center;
  min-width: max-content;
}

.img-width-slider {
  width: 200px;
  background: transparent;
}

.ruler-toggle {
  margin: 0 12px;
}

.img-width-slider::-webkit-slider-runnable-track {
  background: #1565c0;
  height: 6px;
  border-radius: 999px;
}

.img-width-slider::-moz-range-track {
  background: #1565c0;
  height: 6px;
  border-radius: 999px;
}

.img-width-slider::-ms-track {
  background: #1565c0;
  border-color: transparent;
  color: transparent;
  height: 6px;
  border-radius: 999px;
}

.img-width-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  background: #ffffff;
  border: 2px solid #1565c0;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  margin-top: -6px;
}

.img-width-slider::-moz-range-thumb {
  background: #ffffff;
  border: 2px solid #1565c0;
  border-radius: 50%;
  height: 18px;
  width: 18px;
}

.img-width-slider::-ms-thumb {
  background: #ffffff;
  border: 2px solid #1565c0;
  border-radius: 50%;
  height: 18px;
  width: 18px;
}
</style>
